import * as React from 'react';
const SvgArchive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    viewBox="0 0 16 17"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.5 1.5v1.833h12.25V1.5zM0 1.167C0 .522.522 0 1.167 0h12.916c.644 0 1.167.522 1.167 1.167v2.5c0 .644-.523 1.166-1.167 1.166H1.167A1.167 1.167 0 0 1 0 3.667z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.333 4.083v9.167c0 .736.597 1.333 1.334 1.333h7.916c.736 0 1.334-.597 1.334-1.333V4.083h1.5v9.167a2.834 2.834 0 0 1-2.834 2.833H3.667A2.834 2.834 0 0 1 .833 13.25V4.083z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 7.833a.75.75 0 0 1 .75-.75H9.5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArchive;
